<template lang="pug">
div(:class="[$style.wrapper, 'grid gap-32']")
  AvSavings(:class="$style.savingsCallout")
  h2.h4.text-center(v-html="locationData.summaryHeading" :class="$style.heading")
  div(:class="[$style.uspList, 'flex flex-col gap-16']")
    .flex.gap-12.items-center(v-for="item of uspList")
      span(class="text-rebrand2xl leading-none") {{ item.emoji }}
      .text-rebrandSm.content-center
        span(v-html="item.text" :class="[$style.uspText]")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import { GET_LOCATION_INFO } from "~/store/location"

export default defineComponent({
  name: "AvLocalSummary",
  props: {
    block: {
      type: Object as () => Block,
      required: true
    }
  },
  computed: {
    ...mapGetters("location", {
      locationData: GET_LOCATION_INFO
    }),
    uspList() {
      return [
        {
          emoji: this.locationData?.summaryUsp1Emoji?.[0] ?? "",
          text: this.locationData.summaryUsp1
        },
        {
          emoji: this.locationData?.summaryUsp2Emoji?.[0] ?? "",
          text: this.locationData.summaryUsp2
        },
        {
          emoji: this.locationData?.summaryUsp3Emoji?.[0] ?? "",
          text: this.locationData.summaryUsp3
        }
      ]
    }
  }
})
</script>

<style module lang="css">
.wrapper {
  @screen lg {
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas:
      "heading heading"
      "uspList savingsCallout";
  }
}

.heading {
  @screen lg {
    grid-area: heading;
  }
}

.uspList {
  @screen lg {
    @apply justify-evenly;
    grid-area: uspList;
  }
}

.uspText p {
  @screen md {
    @apply text-rebrandSm;
  }
}

.savingsCallout {
  @screen lg {
    grid-area: savingsCallout;
  }
}
</style>
